const emailTemplate = (data) => {
  const { firstName, lastName, phone, email, message, date } = data;

  return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <style>
        @font-face {
          font-family: 'Metropolis-xlight';
          src: url('https://nabaki.netlify.app/static/media/Metropolis-ExtraLight.d1784bd894f8e478ab9f.otf') format('OpenType');
          font-weight: normal;
          font-style: normal;
        }

        body {
          font-family: 'Metropolis-xlight', Arial, sans-serif;
          background-color: #0c0c0c !important; /* Black background */
          color: #fff; /* White text */
          margin: 0;
          padding: 20px;
        }

        .email-container {
          width: 80%;
          max-width: 600px;
          margin: 0 auto;
          background-color: #111;
          padding: 20px;
          border: 1px solid #444;
        }

        .header {
          text-align: start;
          font-size: 22px;
          margin-bottom: 20px;
          color: #fff;
          margin-bottom:4vh;
        }

        .content {
          font-size: 12px;
          line-height: 1.6;
          color: #fff;
        }

        .content p {
          margin: 10px 0;
        }

        .footer {
          text-align: center;
          margin-top: 20px;
          color:#fff;
          font-size: 13px;
          
        }

        .footer img {
          width: 100px;
          margin-top: 10px;
        }
      </style>
    </head>
    <body>
      <div class="email-container">
        <div class="header">
          New Quote Request
        </div>
        <div class="content">
          <p><strong>First Name:</strong> ${firstName}</p>
          <p><strong>Last Name:</strong> ${lastName}</p>
          <p><strong>Phone:</strong> ${phone}</p>
          <p><strong>Email:</strong> ${email}</p>
          <p><strong>Message:</strong></p>
          <p>${message}</p>
          <p><strong>Request Date:</strong> ${date}</p>
          
        </div>
        <div class="footer">
          <p style="background: #000; margin: 0 -20px" >Reply to: <strong>${email} </strong></p>
          <div style=" 
            max-height: 10vh;
            text-align: end;
            width: 100%;
            "
            >
            <img src="https://nabaki.co.za/assests/imgs/Logos/Logos/Brown%20Secondary%20Logo.png" alt="Company Logo" />
           </div>
        </div>  
      </div>
    </body>
    </html>
  `;
};

export default emailTemplate;
